export default {
  common: {
    login: 'Entrar',
    logout: 'Sair',
    support: 'Suporte',
    privacy: 'Política de Privacidade',
    terms: `Termos de Serviço`,
    and: 'e',
    guest: 'Visitante',
    play: 'Jogar',
    install: 'Instalar',
  },
  support: {
    title: `Precisa de ajuda?`,
    description: `Se você joga este jogo e está enfrentando alguma dificuldade,
      teremos o maior prazer em ajudar e responder a todas as suas perguntas`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Ajude o mordomo Austin a transformar uma mansão maravilhosa em um lar acolhedor e confortável.',
    description: `Ajude o mordomo Austin a transformar uma mansão maravilhosa
      em um lar acolhedor e confortável. Pode entrar, você encontrará
      aventuras a partir do momento em que passar pela porta!`,
  },
  cookie: {
    message: 'Usamos cookies para garantir que você tenha a melhor experiência no nosso site',
    link: `Mais informações`,
    button: 'Aceitar',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes no seu computador!
    Instale a versão web do jogo e visite o Austin com apenas alguns cliques!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla é um distribuidor global autorizado de Homescapes',
  },
  game: {
    notSupported: `Incompatível com dispositivos móveis.
      Entre do seu computador para jogar.`,
  },
};
